/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelServizioOperatoreAssegnazioneDTO } from '../model/paged-model-servizio-operatore-assegnazione-dto';
// @ts-ignore
import { ServizioOperatoreAssegnazioneCreationForm } from '../model/servizio-operatore-assegnazione-creation-form';
// @ts-ignore
import { ServizioOperatoreAssegnazioneDTO } from '../model/servizio-operatore-assegnazione-dto';
// @ts-ignore
import { ServizioOperatoreAssegnazionePatchForm } from '../model/servizio-operatore-assegnazione-patch-form';
// @ts-ignore
import { ServizioOperatoreScuoleDTO } from '../model/servizio-operatore-scuole-dto';
// @ts-ignore
import { ServizioOperatoreScuoleReplaceForm } from '../model/servizio-operatore-scuole-replace-form';
// @ts-ignore
import { ServizioOperatoriBulkReplaceForm } from '../model/servizio-operatori-bulk-replace-form';
// @ts-ignore
import { ServizioOperatoriListFilter } from '../model/servizio-operatori-list-filter';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    ServizioOperatoriServiceInterface,
    BulkReplaceServizioOperatoriRequestParams,
    CreateServizioOperatoreRequestParams,
    DeleteServizioOperatoreRequestParams,
    GetServizioOperatoreScuoleRequestParams,
    ListServizioOperatoriRequestParams,
    ReplaceServizioOperatoreScuoleRequestParams,
    UpdateServizioOperatoreRequestParams
} from './servizio-operatori.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class ServizioOperatoriService extends BaseService implements ServizioOperatoriServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Bulk replace delle assegnazioni del servizio.
     * Optimistic lock sulla @Version del parent Servizio. Semantica omessi-rimossi: items non presenti vengono cancellati, items nuovi creati, items invariati restano. Transazione singola.
     * @endpoint put /api/v1/gestione/servizi/{id_servizio}/operatori
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public bulkReplaceServizioOperatori(requestParameters: BulkReplaceServizioOperatoriRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ServizioOperatoreAssegnazioneDTO>>;
    public bulkReplaceServizioOperatori(requestParameters: BulkReplaceServizioOperatoriRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ServizioOperatoreAssegnazioneDTO>>>;
    public bulkReplaceServizioOperatori(requestParameters: BulkReplaceServizioOperatoriRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ServizioOperatoreAssegnazioneDTO>>>;
    public bulkReplaceServizioOperatori(requestParameters: BulkReplaceServizioOperatoriRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idServizio = requestParameters?.idServizio;
        if (idServizio === null || idServizio === undefined) {
            throw new Error('Required parameter idServizio was null or undefined when calling bulkReplaceServizioOperatori.');
        }
        const servizioOperatoriBulkReplaceForm = requestParameters?.servizioOperatoriBulkReplaceForm;
        if (servizioOperatoriBulkReplaceForm === null || servizioOperatoriBulkReplaceForm === undefined) {
            throw new Error('Required parameter servizioOperatoriBulkReplaceForm was null or undefined when calling bulkReplaceServizioOperatori.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/servizi/${this.configuration.encodeParam({name: "idServizio", value: idServizio, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/operatori`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ServizioOperatoreAssegnazioneDTO>>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioOperatoriBulkReplaceForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Assegna un operatore esistente al servizio.
     * Audience: SUPERADMIN, OP_COMUNE (solo nei propri comuni). Target deve essere gia\&#39; un operatore-servizio mensa (OP_SCUOLA o OP_CENTRO_COTTURA).
     * @endpoint post /api/v1/gestione/servizi/{id_servizio}/operatori
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createServizioOperatore(requestParameters: CreateServizioOperatoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioOperatoreAssegnazioneDTO>;
    public createServizioOperatore(requestParameters: CreateServizioOperatoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioOperatoreAssegnazioneDTO>>;
    public createServizioOperatore(requestParameters: CreateServizioOperatoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioOperatoreAssegnazioneDTO>>;
    public createServizioOperatore(requestParameters: CreateServizioOperatoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idServizio = requestParameters?.idServizio;
        if (idServizio === null || idServizio === undefined) {
            throw new Error('Required parameter idServizio was null or undefined when calling createServizioOperatore.');
        }
        const servizioOperatoreAssegnazioneCreationForm = requestParameters?.servizioOperatoreAssegnazioneCreationForm;
        if (servizioOperatoreAssegnazioneCreationForm === null || servizioOperatoreAssegnazioneCreationForm === undefined) {
            throw new Error('Required parameter servizioOperatoreAssegnazioneCreationForm was null or undefined when calling createServizioOperatore.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/servizi/${this.configuration.encodeParam({name: "idServizio", value: idServizio, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/operatori`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioOperatoreAssegnazioneDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioOperatoreAssegnazioneCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Revoca l\&#39;assegnazione (idempotente).
     * 204 sia se la riga esisteva e viene cancellata, sia se non esisteva.
     * @endpoint delete /api/v1/gestione/servizi/{id_servizio}/operatori/{user_id}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteServizioOperatore(requestParameters: DeleteServizioOperatoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteServizioOperatore(requestParameters: DeleteServizioOperatoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteServizioOperatore(requestParameters: DeleteServizioOperatoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteServizioOperatore(requestParameters: DeleteServizioOperatoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idServizio = requestParameters?.idServizio;
        if (idServizio === null || idServizio === undefined) {
            throw new Error('Required parameter idServizio was null or undefined when calling deleteServizioOperatore.');
        }
        const userId = requestParameters?.userId;
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling deleteServizioOperatore.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/servizi/${this.configuration.encodeParam({name: "idServizio", value: idServizio, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/operatori/${this.configuration.encodeParam({name: "userId", value: userId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Scuole assegnate a un operatore su questo servizio.
     * Audience: SUPERADMIN, OP_COMUNE (solo nei propri comuni). Ritorna le scuole assegnate all\&#39;operatore piu\&#39; la copertura sul totale assegnabile (scuole di plesso attivo). Un insieme vuoto su un OP_SCUOLA significa che l\&#39;operatore NON vede alcun dato del servizio (gate fail-closed), non che la configurazione e\&#39; assente.
     * @endpoint get /api/v1/gestione/servizi/{id_servizio}/operatori/{user_id}/scuole
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getServizioOperatoreScuole(requestParameters: GetServizioOperatoreScuoleRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioOperatoreScuoleDTO>;
    public getServizioOperatoreScuole(requestParameters: GetServizioOperatoreScuoleRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioOperatoreScuoleDTO>>;
    public getServizioOperatoreScuole(requestParameters: GetServizioOperatoreScuoleRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioOperatoreScuoleDTO>>;
    public getServizioOperatoreScuole(requestParameters: GetServizioOperatoreScuoleRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idServizio = requestParameters?.idServizio;
        if (idServizio === null || idServizio === undefined) {
            throw new Error('Required parameter idServizio was null or undefined when calling getServizioOperatoreScuole.');
        }
        const userId = requestParameters?.userId;
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getServizioOperatoreScuole.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/servizi/${this.configuration.encodeParam({name: "idServizio", value: idServizio, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/operatori/${this.configuration.encodeParam({name: "userId", value: userId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/scuole`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioOperatoreScuoleDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata operatori assegnati al servizio.
     * Filtri opzionali: q, ruolo. Default sort: user.cognome ASC, user.nome ASC.
     * @endpoint get /api/v1/gestione/servizi/{id_servizio}/operatori
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listServizioOperatori(requestParameters: ListServizioOperatoriRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelServizioOperatoreAssegnazioneDTO>;
    public listServizioOperatori(requestParameters: ListServizioOperatoriRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelServizioOperatoreAssegnazioneDTO>>;
    public listServizioOperatori(requestParameters: ListServizioOperatoriRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelServizioOperatoreAssegnazioneDTO>>;
    public listServizioOperatori(requestParameters: ListServizioOperatoriRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idServizio = requestParameters?.idServizio;
        if (idServizio === null || idServizio === undefined) {
            throw new Error('Required parameter idServizio was null or undefined when calling listServizioOperatori.');
        }
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listServizioOperatori.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listServizioOperatori.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/servizi/${this.configuration.encodeParam({name: "idServizio", value: idServizio, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/operatori`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelServizioOperatoreAssegnazioneDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sostituisce le scuole assegnate a un operatore su questo servizio.
     * Audience: SUPERADMIN, OP_COMUNE (solo nei propri comuni). Replace, non merge: l\&#39;insieme inviato diventa quello vigente. scuole_ids vuoto e\&#39; ammesso e REVOCA l\&#39;accesso dell\&#39;operatore ai dati del servizio (gate fail-closed) - l\&#39;interfaccia deve dichiararlo prima di salvare. Ogni id deve appartenere a questo servizio (404 sul primo estraneo). Non applicabile a OP_CENTRO_COTTURA, che vede sempre tutte le scuole (400). version e\&#39; quella del Servizio parent.
     * @endpoint put /api/v1/gestione/servizi/{id_servizio}/operatori/{user_id}/scuole
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public replaceServizioOperatoreScuole(requestParameters: ReplaceServizioOperatoreScuoleRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioOperatoreScuoleDTO>;
    public replaceServizioOperatoreScuole(requestParameters: ReplaceServizioOperatoreScuoleRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioOperatoreScuoleDTO>>;
    public replaceServizioOperatoreScuole(requestParameters: ReplaceServizioOperatoreScuoleRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioOperatoreScuoleDTO>>;
    public replaceServizioOperatoreScuole(requestParameters: ReplaceServizioOperatoreScuoleRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idServizio = requestParameters?.idServizio;
        if (idServizio === null || idServizio === undefined) {
            throw new Error('Required parameter idServizio was null or undefined when calling replaceServizioOperatoreScuole.');
        }
        const userId = requestParameters?.userId;
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling replaceServizioOperatoreScuole.');
        }
        const servizioOperatoreScuoleReplaceForm = requestParameters?.servizioOperatoreScuoleReplaceForm;
        if (servizioOperatoreScuoleReplaceForm === null || servizioOperatoreScuoleReplaceForm === undefined) {
            throw new Error('Required parameter servizioOperatoreScuoleReplaceForm was null or undefined when calling replaceServizioOperatoreScuole.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/servizi/${this.configuration.encodeParam({name: "idServizio", value: idServizio, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/operatori/${this.configuration.encodeParam({name: "userId", value: userId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/scuole`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioOperatoreScuoleDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioOperatoreScuoleReplaceForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Aggiorna la riga di assegnazione (optimistic lock).
     * version client-driven sulla riga user_servizio. Se ruolo_servizio e\&#39; presente deve coincidere con l\&#39;authority del target.
     * @endpoint patch /api/v1/gestione/servizi/{id_servizio}/operatori/{user_id}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateServizioOperatore(requestParameters: UpdateServizioOperatoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioOperatoreAssegnazioneDTO>;
    public updateServizioOperatore(requestParameters: UpdateServizioOperatoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioOperatoreAssegnazioneDTO>>;
    public updateServizioOperatore(requestParameters: UpdateServizioOperatoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioOperatoreAssegnazioneDTO>>;
    public updateServizioOperatore(requestParameters: UpdateServizioOperatoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idServizio = requestParameters?.idServizio;
        if (idServizio === null || idServizio === undefined) {
            throw new Error('Required parameter idServizio was null or undefined when calling updateServizioOperatore.');
        }
        const userId = requestParameters?.userId;
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling updateServizioOperatore.');
        }
        const servizioOperatoreAssegnazionePatchForm = requestParameters?.servizioOperatoreAssegnazionePatchForm;
        if (servizioOperatoreAssegnazionePatchForm === null || servizioOperatoreAssegnazionePatchForm === undefined) {
            throw new Error('Required parameter servizioOperatoreAssegnazionePatchForm was null or undefined when calling updateServizioOperatore.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/servizi/${this.configuration.encodeParam({name: "idServizio", value: idServizio, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/operatori/${this.configuration.encodeParam({name: "userId", value: userId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioOperatoreAssegnazioneDTO>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioOperatoreAssegnazionePatchForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
